import { useRef } from 'react';
import domToImage from 'dom-to-image-more';
import cm from 'classnames';

import { AspectRatioStory } from 'services/story.service';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { uploadTitleCreditsImage } from 'components/app/_mediator/app-files.slice';
import { resolveTitleCreditsGenerator } from 'components/app/editor/_mediator/monitor/monitor-req.slice';

import { __TextLayer } from './_text-layer';
import styles from './_title-credits.module.scss';

export const TitleCreditsGenerator = () => {
  const projectId = useAppSelector((state) => state.projects.selectedProject);
  const data = useAppSelector((state) => state.monitor.titleCreditsData);

  const dispatch = useAppDispatch();
  const generatorRef = useRef<HTMLDivElement>(null);

  const onReady = async () => {
    if (!projectId || !data) return;
    try {
      const { storyId, key } = data;
      const blob = await domToImage.toBlob(generatorRef.current, { bgcolor: null });
      // const url = URL.createObjectURL(blob);
      // window.open(url, '_blank');
      await dispatch(uploadTitleCreditsImage({ payload: { projectId, storyId, key }, blob }));
    } catch (err) {
      console.error('Error', err);
    } finally {
      dispatch(resolveTitleCreditsGenerator());
    }
  };

  return (
    <div ref={generatorRef} className={styles.Generator}>
      {data && (
        <div
          className={cm(styles.Generator__el, {
            [styles['Generator__el--vertical']]: data?.aspectRatio === AspectRatioStory.is9x16,
          })}
        >
          <__TextLayer text={data.text} preset={data.preset} onReady={onReady} />
        </div>
      )}
    </div>
  );
};
